import { toast, loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { JWTService } from '@/shared/services/jwt'
import AccountMixin from '@/store/module/account/mixin'

import AccountRepository from '@/shared/http/repositories/access/account'
import AccountModel from '@/shared/models/access/changepasswordmodel'
import AccountForms from './profile-form'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'profile',
  mixins: [ActionsForm, AccountMixin],
  data () {
    return {
      data: AccountModel,
      form: AccountForms,
      lengthValid: false,
      uppercaseValid: false,
      lowercaseValid: false,
      numberValid: false,
      specialCharValid: false
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    validatePassword (password) {
      this.lengthValid = password.length >= 8
      this.uppercaseValid = /[A-Z]/.test(password)
      this.lowercaseValid = /[a-z]/.test(password)
      this.numberValid = /\d/.test(password)
      this.specialCharValid = /[!@#$%&*()+-]/.test(password)
    },
    onLoad () {
      Tools.ClearDataForms(this.form, {...this.data, confirmation: null})
    },
    onUpdate () {
      if (this.onCheckPassword()) {
        loading.push()
        Tools.ValidateForms(this.form, this.data, self, toast)

        if (this.data.newPassword) {
          this.data.newPassword = this.data.newPassword.toString()
        } else {
          this.data.newPassword = ''
        }

        AccountRepository.FirstChangePassword({
          username: this.account.username,
          ...this.data
        })
          .then((response) => {
            if (response.status === 200) {
              toast.success('Senha alterada com sucesso!')
              setTimeout(() => {
                JWTService.DestroyToken()
                this.$router.push('/login')
              }, 1500)
            }
          })
          .catch((err) => {
            advancedOnException(err, this.$lang)
            loading.pop()
          })
      }
    },
    onCheckPassword () {
      if (this.form.currentPassword.value != null || this.form.newPassword.value != null) {
        if (this.form.currentPassword.value === null) {
          toast.error('Informe sua senha atual!')
          return false
        } else if (this.form.newPassword.value === null) {
          toast.error('Informe a nova senha!')
          // this.resetPasswordFields()
          return false
        } else if (this.form.confirmation.value === null) {
          toast.error('Informe a confirmação da nova senha!')
          // this.resetPasswordFields()
          return false
        } else if (this.form.currentPassword.value === this.form.newPassword.value) {
          toast.error('A nova senha não pode ser igual a antiga!')
          // this.resetPasswordFields()
          return false
        } else if (this.form.newPassword.value !== this.form.confirmation.value) {
          toast.error('A confirmação da nova senha não é válida!')
          // this.resetPasswordFields()
          return false
        }
      }
      return true
    },
    resetPasswordFields () {
      this.form.newPassword.value = ''
      this.form.confirmation.value = ''
      this.lengthValid = false
      this.uppercaseValid = false
      this.lowercaseValid = false
      this.numberValid = false
      this.specialCharValid = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile.js